import * as React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAppGroupsForOrgId } from '../helpers';
import { RootState } from '../reducers/reducers';
import { AppRouteComponentMatchParams, OrgComponentProps } from '../typescriptHelpers';
import AppGroupIconComponent from './AppGroupIconComponent';
import { AppGroup } from '../types';
import routes from '../routes';
import { selectOrg } from '../selectors/selectors';

const AppAvatars: React.FC<OrgComponentProps> = (props: OrgComponentProps) => {
    const appRouteMatch = useRouteMatch<AppRouteComponentMatchParams>(routes.app);
    const selectedAppId = appRouteMatch ? appRouteMatch.params.appIdParam : null;

    const orgIdParam = useSelector((state: RootState) => selectOrg(state).orgId);
    const appGroups = useSelector((state: RootState) => getAppGroupsForOrgId(props.orgId, state));
    const filteredAppGroups = appGroups.filter((appGroup) => appGroup.appIds.length !== 0);

    const appAvatars = (appGroups: AppGroup[]) => {
        return appGroups.map((appGroup) => {
            return (
                <li style={{ paddingTop: 16 }} key={appGroup.id}>
                    <AppGroupIconComponent
                        orgIdParam={orgIdParam}
                        orgId={props.orgId}
                        appGroupId={appGroup.id}
                        selectedAppIdParam={selectedAppId}
                    />
                </li>
            );
        });
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'flex-start',
            }}
        >
            <ul style={{ listStyleType: 'none', margin: 0, padding: 0 }}>{appAvatars(filteredAppGroups)}</ul>
        </div>
    );
};

export default AppAvatars;
